import { ColorProperty } from "./colorproperty";

export class LineColorProperty extends ColorProperty{
    
}